import script from "./PixAccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./PixAccountView.vue?vue&type=script&setup=true&lang=js"

import "./PixAccountView.vue?vue&type=style&index=0&id=45b36bb6&scoped=true&lang=css"
import "./PixAccountView.vue?vue&type=style&index=1&id=45b36bb6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45b36bb6"]])

export default __exports__